export default __webpack_public_path__ + "static/media/entrepreneur.f0372d68.png";